import { Link } from 'react-router-dom';

const questions = [
  'Material(s) planned to be baled?',
  'Size of material that will need to freely fall into the baler infeed hopper?',
  'Pounds or tons per hour for each material?',
  'Loose infeed density?',
  'Bale size needed and shipping method?',
  'Most efficient method of moving material to the baling area?',
  'Best way to load materials into the baler?',
  'Available space and electrical power in the baling area?',
];

const openingHeaders = ['Model Series', 'Opening Length', 'Opening Width'];

const openingRows = [
  ['CM2424 Series', '24"', '24"'],
  ['CM3030 Series', '30"', '30"'],
  ['CM3060 Series', '30"', '60"'],
  ['CM3430 Series', '34"', '30"'],
  ['CM3442 Series', '34"', '42"'],
  ['CM5030 Series', '50"', '30"'],
  ['CM5042 Series', '50"', '42"'],
  ['CM5046 Series', '50"', '46"'],
  ['CM6042 Series', '60"', '42"'],
  ['CM6046 Series', '60"', '46"'],
  ['CM7842 Series', '78"', '42"'],
  ['CM7846 Series', '78"', '46"'],
];

const cylinderRows = ['6"', '7"', '8"', '9"', '10"', '12"'];

function BalerSelectionGuide() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link className="active" to="/baler-selection-guide">Baler Selection Guide</Link>
          <Link to="/horizontal-manual-tie-balers">Horizontal Manual Tie Balers</Link>
          <Link to="/horizontal-automatic-tie-balers">Horizontal Automatic Tie Balers</Link>
          <Link to="/multi-material-full-eject-balers">Multi-Material Full Eject Balers</Link>
          <Link to="/vertical-down-packing-balers">Vertical &amp; Down-Packing Balers</Link>
          <Link to="/contact/questionnaire">Questionnaire</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Selection Guide</span>
          <h2>Choose the baler that fits your application</h2>
          <div className="body-copy page-summary-copy">C+M balers are designed for baling paper, corrugated (cardboard), non-wovens, plastics, textiles, foam rubber, fiberglass, carpet, tobacco, agriculture waste, <strong>used clothing</strong>, biomass, non-ferrous metals, cotton or <strong>man-made fibers</strong>, and other materials.</div>
          <div className="page-summary-notes">
            {questions.map((item) => <span key={item}>{item}</span>)}
          </div>
          <div className="content-stack">
            <section className="content-block">
              <h3>Styles Or Types Of Balers</h3>
              <div className="body-copy">There are several styles of balers and baling presses. Horizontal balers in general are the most efficient, and <strong>horizontal automatic tie balers</strong> are for higher production rates. Vertical down-stroke balers are for lower volumes or special materials.</div>
              <div className="body-copy">Most <strong>horizontal balers</strong> retain completed bales inside the <strong>baling chamber</strong> until other completed bales push them out of the chamber. The determination as to what style of baler best fits your application is primarily determined by the volume of material, the size of the material, and sometimes the type of material.</div>
              <div className="body-copy">Availability of labor to load and operate the <strong>baling press</strong> is an important consideration.</div>
            </section>
            <section className="content-block">
              <h3>Standard Design Horizontal Baler Model Descriptions</h3>
              <div className="body-copy">There are four styles of standard C+M horizontal balers: <strong>closed-end manual tie</strong>, open-end manual tie, open-end automatic tie, and <strong>full-eject manual tie</strong>.</div>
              <div className="body-copy">Baler throughput is determined by the cubic feet of displacement within the <strong>baling chamber</strong> while the baler ram cycles into the baling chamber.</div>
              <div className="body-copy">Throughput or capacity is determined by style of baler, length and width of <strong>infeed opening</strong>, height of bale, length of bale, speed of <strong>compression cylinder</strong>, and the characteristics of the material being baled or loose infeed density versus final bale density.</div>
              <div className="body-copy">Common bale heights are available: 24 inches, 30 inches, 40 inches, or 42 inches.</div>
            </section>
            <section className="content-block">
              <h3>Horizontal Baler Model Opening Guide</h3>
              <div className="body-copy">Many hopper <strong>infeed openings</strong> are available as indicated by C+M model series numbers. Additional hopper sections are available by quotation, including 48 inch high hoppers over the baler body, 3-1/2 sided hoppers with optional flared sides, and <strong>custom hopper configurations</strong> for specialized applications.</div>
              <div className="spec-table-block">
                <table className="spec-table">
                  <thead>
                    <tr>{openingHeaders.map((header) => <th key={header}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {openingRows.map((row) => (
                      <tr key={row[0]}>{row.map((cell, cellIndex) => <td key={`${row[0]}-${cellIndex}`}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            <section className="content-block">
              <h3>Compression Cylinders</h3>
              <div className="body-copy">Compression cylinder bore diameter is one of the major factors in final compression force. Not all cylinder sizes are available for every baler model.</div>
              <div className="spec-table-block compact-spec-table-block">
                <table className="spec-table compact-spec-table">
                  <thead>
                    <tr><th>Cylinder Inner Diameter</th></tr>
                  </thead>
                  <tbody>
                    {cylinderRows.map((diameter) => (
                      <tr key={diameter}><td>{diameter}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            <section className="content-block">
              <h3>Power Units & Electrical</h3>
              <div className="body-copy">Power unit electric motors and hydraulic pump selections determine the speed of the <strong>baler compression cylinder</strong>. C+M <strong>hydraulic power units</strong> are designed with a single 10 HP to 75 HP primary motor or twin motor power units with two 20 HP up to two 75 HP motors. C+M auto-tie models have a separate 15 HP hydraulic system.</div>
              <div className="body-copy">When a baler is to be located outdoors, NEMA-4 electrics, special paint, and hydraulic fluid heaters are needed.</div>
            </section>
          </div>
        </article>
      </section>
    </main>
  );
}

export default BalerSelectionGuide;
